import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './checkbox-field.scss';

class CheckboxField extends PureComponent {
  render() {
    const { label, error, ...props } = this.props;

    return (
      <div className="field-container checkbox">
        <label className={cn({ error })}>
          <input
            type="checkbox"
            formNoValidate
            {...props}
          />

          <span className="pseudo-checkbox"/>

          <div>{label}</div>
        </label>
      </div>
    );
  }
}

CheckboxField.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  content: PropTypes.node
};

export default CheckboxField;



// WEBPACK FOOTER //
// ./src/components/widgets/CheckBoxField/index.js